import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const queries = buildGraphqlQuery(
  'Blog',
  `_id
  title
  slug
  contentHtml
  summary
  updatedAt
  status
  cover
  remarks
  tags
  transcribingMetadata {
    status
    jobId
    startedAt
    videoCount
  }`
)
export const buildQuery = (field) => buildGraphqlQuery('Blog', `_id updatedAt ${field}`)
